import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

interface GroupedSelectProps {
  label: string;
  id: string;
  defaultValue?: string | number;
  options: any;
  onChange?: (event: any) => void;
}

export default function EventEHRGroupedSelect({
  label,
  id,
  defaultValue = "",
  options,
  onChange,
}: GroupedSelectProps) {
  return (
    <FormControl sx={{ minWidth: "100%" }}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        size="small"
        defaultValue={defaultValue}
        id={id}
        label={label}
        MenuProps={{
          PaperProps: {
            // Keep the dropdown scrollable when there are many options.
            style: { maxHeight: 300 },
          },
        }}
        onChange={(e) => {
          onChange && onChange(e);
        }}
      >
        {options.map((option: any, index: number) =>
          option.type === "subheader" ? (
            <ListSubheader key={index}>{option.label}</ListSubheader>
          ) : (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          )
        )}
      </Select>
    </FormControl>
  );
}
